/**
 * HM-552 Multi-hotel — client API tenant config.
 */
import { api } from './client.js';

export type TenantFeatures = {
  enable_day_use: boolean;
  enable_overnight: boolean;
  enable_room_service: boolean;
  enable_alloggiati: boolean;
  enable_garage: boolean;
  card_provider: 'mifare' | 'hid' | 'custom' | null;
};

export type Tenant = {
  id: string;
  name: string;
  slug: string;
  address: string | null;
  city: string | null;
  province: string | null;
  cap: string | null;
  phone: string | null;
  email: string | null;
  vatNumber: string | null;
  accessMethod: 'code' | 'card' | 'mixed' | 'key';
  featuresJson: TenantFeatures;
  createdAt: string;
  updatedAt: string;
};

export async function getCurrentTenant(): Promise<{ tenant: Tenant }> {
  return api('/tenant/me');
}

export async function patchCurrentTenant(
  patch: Partial<Omit<Tenant, 'id' | 'slug' | 'featuresJson' | 'createdAt' | 'updatedAt'>> & {
    features?: Partial<TenantFeatures>;
  },
): Promise<{ tenant: Tenant }> {
  return api('/tenant/me', { method: 'PATCH', body: JSON.stringify(patch) });
}
